import PeriodControls from '../../common/PeriodControls';
import styles from './styles/dashboard-period-controls.module.scss';

const PERIOD_OPTIONS = [
    { label: 'MTD', value: '1m' },
    { label: '3MTD', value: '3m' },
    { label: '6MTD', value: '6m' },
    { label: 'YTD', value: 'ytd' },
    { label: 'Custom', value: 'custom' },
];

function DashboardPeriodControls({
    timeFrame,
    dateRange,
    onTimeFrameChange,
    onDateRangeChange,
}) {
    return (
        <div className={styles.toolbar}>
            <div className={styles.cluster}>
                <PeriodControls
                    timeFrame={timeFrame}
                    dateRange={dateRange}
                    onTimeFrameChange={onTimeFrameChange}
                    onDateRangeChange={onDateRangeChange}
                    options={PERIOD_OPTIONS}
                    showLabel={true}
                />
            </div>
        </div>
    );
}

export default DashboardPeriodControls;
